import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CardEventMsg } from './enums/CardEventMsg.enum';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CardComponent {

  @Input() title = '';
  @Input() subtitle = '';
  @Input() eventMsg: CardEventMsg | null;
  @Input() hasNoData: boolean;
  @Input() size: 'card-default' | 'card-sm' | 'card-md' | 'card-lg' | 'card-fix-sm' | 'card-fix-md' | 'card-fix-lg' | 'card-fix-default' |'card-auto' | 'card-fix-xs' | 'card-xs' = 'card-default';
  @Input() fullscreenEnable: boolean = true;

  readonly errorGettingData = 'errorGettingData';
  readonly successCreate = 'successCreate';
  readonly successUpdate = 'successUpdate';
  readonly noData = 'noData';

  CARD_EVENT_MSG = CardEventMsg;
  isFullscreen = false;

  constructor() {
  }

  toggleFullscreen(): void {
    this.isFullscreen = !this.isFullscreen;
    console.log(this.isFullscreen)
  }
}
